<template>
  <Dialog
    class="dialog"
    v-model:visible="display"
    style="
      width: 355px;
      height: 210px;
      border-radius: 6px;
      background-color: white;
    "
  >
    <template #header>
      <div
        :style="{
          color:
            uyari == 'Error' ? 'red' : uyari == 'Warning' ? '#fc6c2a' : 'green',
          'font-size': 'large',
          'font-weight': '500',
          display: 'flex',
          'align-items': 'center',
        }"
      >
        <img
          loading="lazy"
          v-if="uyari == 'Error'"
          src="/img/errorIcon.png"
          style="width: 48px; height: 48px"
        />
        <img
          loading="lazy"
          v-if="uyari == 'Success'"
          src="/img/successIcon.png"
          style="width: 48px; height: 48px"
        />
        <img
          loading="lazy"
          v-if="uyari == 'Warning'"
          src="/img/warningIcon.png"
          style="width: 48px; height: 48px"
        />
        {{ uyari }}
      </div>
    </template>
    <div
      style="
        padding: 1rem;
        margin: auto;
        font-family: 'Jost';
        font-style: normal;
        font-weight: 500 !important;
        font-size: 18px;
        line-height: 20px;
        color: #444444;
        text-align: center;
      "
    >
      {{ message }}
    </div>
  </Dialog>
  <Dialog
    @maximize="isMaximize = true"
    @unmaximize="isMaximize = false"
    v-model:visible="cvappear"
    maximizable
    modal
    :header="`${dataTableClickName} CV`"
    :style="{ width: '50rem' }"
    :breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
  >
    <div style="position: relative; height: 100%">
      <Skeleton
        style="
          position: absolute;
          left: 0;
          top: 0;
          right: 0;
          bottom: 0;
          z-index: 9;
          width: 100% !important;
          height: 100% !important;
        "
        width="300px"
        height="300px"
        v-if="!onLoadView && !onLoadSelected"
      />
      <iframe
        class="w-100"
        v-if="showCV && !selectedCvView"
        :style="{ height: isMaximize ? '100%' : '500px' }"
        :src="`${cvLink + cvData[0]?.path + '#toolbar=0&navpanes=0'}`"
        frameborder="0"
        @load="onLoadView = true"
        ref="cvViewer"
      />
      <iframe
        class="w-100"
        v-if="showCV && selectedCvView"
        :style="{ height: isMaximize ? '100%' : '500px' }"
        :src="`${cvLink + selectedCv.path + '#toolbar=0&navpanes=0'}`"
        frameborder="0"
        @load="onLoadSelected = true"
        ref="cvSelectedViewer"
      />
    </div>
  </Dialog>

  <div
    v-if="loadingFile"
    style="
      text-align: center;
      background: rgba(128, 128, 128, 0.75);
      position: fixed;
      padding: 0;
      margin: 0;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 9;
    "
  >
    <i
      class="pi pi-spin pi-spinner"
      style="
        z-index: 11;
        margin-top: 15vw;
        font-size: xxx-large;
        color: #fc6c2a;
      "
    />
    <h6 style="z-index: 10; color: white">{{ $t('loadingFile') }}</h6>
  </div>
  <!-- <div>
        <label style="font-family: 'Jost';font-style: normal;font-weight: 700;font-size: 16px;line-height: 23px;color: #103660;">
          {{this.product?.short_name+' / '+this.product?.company_name  }}
        </label>
      </div> -->
  <form
    @submit.prevent="handleLogin(!v$.$invalid)"
    class="p-fluid"
    autocomplete="off"
  >
    <div style="display: flex; justify-content: flex-end"></div>
    <div class="input-panel p-d-flex p-flex-column p-px-3" style="gap: 15px">
      <div class="p-inputgroup">
        <label
          style="
            font-family: 'Jost';
            font-style: normal;
            font-weight: 700;
            font-size: 16px;
            line-height: 23px;
            color: #103660;
            margin-bottom: 15px;
          "
          :title="product.short_name"
          class="pointer"
        >
          {{
            product.short_name && product.short_name.length > 80
              ? `${product.short_name.slice(0, 80)}... / ${
                  product.company_name
                }`
              : `${product.short_name || ''} / ${product.company_name || ''}`
          }}
        </label>
      </div>
      <div class="p-inputgroup" style="gap: 30px">
        <div class="p-float-label">
          <InputText
            disabled
            type="firstname"
            id="firstname"
            v-model="v$.firstname.$model"
            :class="{ 'p-invalid': v$.firstname.$invalid && submitted }"
            :style="{
              'border-color':
                v$.firstname.$invalid && submitted
                  ? errorBorderColor
                  : '#DBDBDB',
              'border-style': 'solid',
              'border-width': '1px',
              'border-radius': '6px',
              'box-sizing': 'border-box',
              'max-width': '320px',
              height: '46px',
              'padding-left': '0.5rem',
            }"
          />
          <label
            style="
              font-size: medium;
              font-family: 'Jost';
              font-style: normal;
              font-weight: 400;
              font-size: 12px;
              line-height: 17px;
              color: #444444;
            "
            for="firstname"
            :class="{ 'p-error': v$.firstname.$invalid && submitted }"
            :style="v$.firstname.$invalid && submitted ? colorRed : ''"
          >
            {{
              v$.firstname.$invalid && submitted
                ? $t('firstname') + '*'
                : $t('firstname')
            }}
          </label>
        </div>
        <!-- <small  style="position: absolute; pointer-events: none;top: 50%;margin-top: -.5rem;font-family: 'Jost';font-style: normal;font-weight: 600;font-size: 10px;line-height: 16px;color: rgba(48, 57, 82, 0.6);" >
                      {{ $t('enterkeyword') }}
                 </small> -->
        <!--
            </div>


            <div class="p-inputgroup"> -->

        <div class="p-float-label">
          <InputText
            disabled
            type="lastname"
            id="lastname"
            v-model="v$.lastname.$model"
            :class="{ 'p-invalid': v$.lastname.$invalid && submitted }"
            :style="{
              'border-color':
                v$.lastname.$invalid && submitted
                  ? errorBorderColor
                  : '#DBDBDB',
              'border-style': 'solid',
              'border-width': '1px',
              'border-radius': '6px',
              'box-sizing': 'border-box',
              'max-width': '320px',
              height: '46px',
              'padding-left': '0.5rem',
            }"
          />
          <label
            style="
              font-size: medium;
              font-family: 'Jost';
              font-style: normal;
              font-weight: 400;
              font-size: 12px;
              line-height: 17px;
              color: #444444;
            "
            for="lastname"
            :class="{ 'p-error': v$.lastname.$invalid && submitted }"
            :style="v$.lastname.$invalid && submitted ? colorRed : ''"
          >
            {{
              v$.lastname.$invalid && submitted
                ? $t('lastname') + '*'
                : $t('lastname')
            }}
          </label>
        </div>
        <!-- <small  style="position: absolute; pointer-events: none;top: 50%;margin-top: -.5rem;font-family: 'Jost';font-style: normal;font-weight: 600;font-size: 10px;line-height: 16px;color: rgba(48, 57, 82, 0.6);" >
                      {{ $t('enterkeyword') }}
                 </small> -->
      </div>

      <div class="p-inputgroupd">
        <div class="p-float-label">
          <InputText
            disabled
            type="linkedinPage"
            id="linkedinPage"
            v-model="v$.linkedinPage.$model"
            :class="{ 'p-invalid': v$.linkedinPage.$invalid && submitted }"
            :style="{
              'border-color':
                v$.linkedinPage.$invalid && submitted
                  ? errorBorderColor
                  : '#DBDBDB',
              'border-style': 'solid',
              'border-width': '1px',
              'border-radius': '6px',
              'box-sizing': 'border-box',
              'max-width': '669px',
              height: '46px',
              'padding-left': '0.5rem',
            }"
          />
          <label
            style="
              font-size: medium;
              font-family: 'Jost';
              font-style: normal;
              font-weight: 400;
              font-size: 12px;
              line-height: 17px;
              color: #444444;
            "
            for="linkedinPage"
            :class="{ 'p-error': v$.linkedinPage.$invalid && submitted }"
            :style="v$.linkedinPage.$invalid && submitted ? colorRed : ''"
          >
            {{
              v$.linkedinPage.$invalid && submitted
                ? $t('linkedinPage') + '*'
                : $t('linkedinPage')
            }}
          </label>
        </div>
        <small v-if="!linkedinPage" class="p-error">
          LinkedIn URL not found. Please update it from your
          <router-link
            class="p-error"
            style="text-decoration: underline"
            to="/chrs/profile"
            >profile</router-link
          >.
        </small>
        <!-- <small  style="position: absolute; pointer-events: none;top: 50%;margin-top: -.5rem;font-family: 'Jost';font-style: normal;font-weight: 600;font-size: 10px;line-height: 16px;color: rgba(48, 57, 82, 0.6);" >
                      {{ $t('enterkeyword') }}
                 </small> -->
      </div>

      <div class="p-inputgroup flex-column">
        <div class="p-float-label">
          <Textarea
            type="info"
            id="info"
            v-model="info"
            :maxlength="512"
            :style="{
              'border-color': '#DBDBDB',
              'border-style': 'solid',
              'border-width': '1px',
              'border-radius': '6px',
              'box-sizing': 'border-box',
            }"
            rows="3"
            cols="30"
          />
          <label
            style="
              font-size: medium;
              font-family: 'Jost';
              font-style: normal;
              font-weight: 400;
              font-size: 12px;
              line-height: 17px;
              color: #444444;
            "
            for="linkedin"
          >
            {{ $t('aditionalinfo') }}
          </label>
        </div>
        <small style="color: #666; font-size: 0.875rem; margin-top: 0.25rem">
          {{ info ? info.length : 0 }}/512
        </small>
      </div>

      <div class="p-inputgroup">
        <div class="d-flex justify-content-center">
          <div class="d-flex flex-column gap-3">
            <div
              class="d-flex align-items-center justify-content-center"
              style="gap: 15px"
            >
              <div
                class="d-flex align-items-center"
                v-if="cvs.length !== 0 && !cvs[0]?.status"
              >
                <RadioButton
                  v-model="uploadCV"
                  inputId="uploadnewCV"
                  name="cv"
                  value="latestCV"
                />
                <label for="uploadnewCV" class="ml-2 mb-0">{{
                  $t('uselatestCv')
                }}</label>
              </div>

              <div class="d-flex align-items-center">
                <RadioButton
                  v-model="uploadCV"
                  inputId="uploadLatestCV"
                  name="cv"
                  value="newCV"
                />
                <label for="uploadLatestCV" class="ml-2 mb-0">{{
                  $t('uploadNewCv')
                }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--cv here-->
      <div
        class="p-inputgroup"
        v-if="uploadCV === 'latestCV' && cvs.length > 0"
      >
        <div class="p-float-label">
          <div class="input-group upload" v-if="cvs.length > 0">
            <div class="upload-container">
              <Dropdown
                class="upload-card"
                v-model="selectedCv"
                :options="cvs"
                optionLabel="name"
                placeholder="Select a CV"
                style="
                  width: 100%;
                  border-width: 2px !important;
                  border-style: dashed !important;
                  border-color: #c2c2c2 !important;
                  border-radius: 14px !important;
                "
              >
                <template #option="slotProps">
                  <div class="d-flex align-items-center" style="gap: 8px">
                    <div
                      style="
                        background-color: #ffebcc;
                        width: 33px;
                        height: 33px;
                        border-radius: 50%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                      "
                    >
                      <i
                        :class="`pi ${
                          slotProps.option?.path?.slice(-3) === 'pdf'
                            ? 'pi-file-pdf'
                            : 'pi-file-word'
                        }`"
                        style="font-size: 16px; color: #fc6c2a"
                      />
                    </div>
                    <div>
                      {{
                        slotProps.option?.name &&
                        slotProps.option?.name.length > 70
                          ? slotProps.option?.name.slice(0, 70) + '...'
                          : slotProps.option?.name
                      }}
                    </div>
                  </div>
                </template>
                <template #value="slotValue">
                  <div class="d-flex" style="gap: 16px" v-if="slotValue.value">
                    <div
                      style="
                        background-color: #ffebcc;
                        width: 33px;
                        height: 33px;
                        border-radius: 50%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                      "
                    >
                      <i
                        :class="`pi ${
                          slotValue.value?.path?.slice(-3) === 'pdf'
                            ? 'pi-file-pdf'
                            : 'pi-file-word'
                        }`"
                        style="font-size: 16px; color: #fc6c2a"
                      />
                    </div>
                    <div class="d-flex flex-column">
                      <div
                        style="
                          font-weight: 600;
                          font-size: 16px;
                          line-height: 23px;
                          color: rgb(68, 68, 68);
                        "
                      >
                        {{
                          slotValue.value?.name &&
                          slotValue.value?.name.length > 45
                            ? slotValue.value?.name.slice(0, 45) + '...'
                            : slotValue.value?.name
                        }}
                      </div>
                      <div
                        style="
                          font-weight: 600;
                          font-size: 16px;
                          line-height: 23px;
                          color: rgba(68, 68, 68, 0.5);
                          width: max-content;
                          text-transform: uppercase;
                        "
                      >
                        {{
                          slotValue.value?.path?.slice(-3) === 'ocx'
                            ? 'docx'
                            : slotValue.value?.path?.slice(-3)
                        }}
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <div class="d-flex align-items-center" style="gap: 16px">
                      <div
                        style="
                          background-color: #ffebcc;
                          width: 33px;
                          height: 33px;
                          border-radius: 50%;
                          display: flex;
                          justify-content: center;
                          align-items: center;
                        "
                      >
                        <i
                          class="pi pi-file"
                          style="font-size: 16px; color: #fc6c2a"
                        />
                      </div>
                      <div class="d-flex flex-column">
                        <div
                          style="
                            font-weight: 600;
                            font-size: 16px;
                            line-height: 23px;
                            color: rgb(68, 68, 68);
                          "
                        >
                          {{ slotValue.placeholder }}
                        </div>

                        <div
                          style="
                            font-weight: 600;
                            font-size: 16px;
                            line-height: 23px;
                            color: rgba(68, 68, 68, 0.5);
                            width: max-content;
                          "
                        >
                          DOC, DOCX, PDF
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </Dropdown>
            </div>
          </div>
        </div>
      </div>
      <div v-if="selectedCv && uploadCV == 'latestCV'">
        <Button
          @click=";(selectedCvView = true), displayCV(selectedCv)"
          label="Show CV"
          style="
            background-color: #f5f5f5;
            border-width: 2px !important;
            border-style: dashed;
            border-color: rgb(194, 194, 194);
            border-radius: 14px;
            font-weight: 600;
            font-size: 16px;
            line-height: 23px;
            color: rgb(68, 68, 68);
          "
        />
      </div>
      <div
        class="p-inputgroup"
        v-if="uploadCV === 'newCV' && !previewImage && !fileType"
      >
        <div class="p-float-label">
          <div class="input-group upload">
            <div class="upload-container">
              <div
                :style="{
                  ' border-color': isfileattached ? '#c2c2c2' : '#B00020',
                }"
                class="upload-card"
              >
                <div class="drop_box" @click="uploadEvent">
                  <div class="upload-im">
                    <img
                      loading="lazy"
                      src="/img/upload.svg"
                      aria-hidden="true"
                    />
                  </div>
                  <div class="upload-text">
                    <span
                      style="
                        font-weight: 600;
                        font-size: 16px;
                        line-height: 23px;
                        color: #444444;
                      "
                    >
                      {{ $t('addCV') }}
                    </span>
                    <span
                      style="
                        font-weight: 600;
                        font-size: 16px;
                        line-height: 23px;
                        color: rgba(68, 68, 68, 0.5);
                        width: max-content;
                      "
                    >
                      DOC, DOCX, PDF
                    </span>
                    <input
                      ref="fileInput"
                      hidden
                      type="file"
                      accept=".doc,.docx,.pdf"
                      id="fileID"
                      @change="uploadImage($event)"
                    />
                  </div>
                  <i class="pi pi-close" @click="clearImage"></i>
                  <div
                    style="width: 100%"
                    v-if="
                      (previewImage && fileType === 'jpg') ||
                      (previewImage && fileType === 'png') ||
                      (previewImage && fileType === 'jpeg')
                    "
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="previewImage && fileType && uploadCV === 'newCV'"
        class="input-group upload"
        style="border: 1px solid #fc6c2a; border-radius: 12px"
      >
        <div
          class="p-d-flex p-ai-center p-jc-center w-100"
          style="
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 14px 26px;
          "
        >
          <div style="display: flex; flex-direction: row; width: 100%">
            <div
              style="
                display: flex;
                flex-direction: row;
                align-items: center;
                flex-grow: 1;
              "
            >
              <img loading="lazy" src="/img/uploadFile.png" />

              <div
                style="
                  display: flex;
                  flex-direction: column;
                  margin-left: 0.5rem;
                  flex-grow: 1;
                "
              >
                <span
                  style="
                    font-family: 'Jost';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 16px;
                    line-height: 20px;
                    color: #444444;
                  "
                >
                  {{
                    fileName && fileName.length > 45
                      ? fileName.slice(0, 45) + '...'
                      : fileName
                  }}
                </span>
                <span
                  style="
                    font-family: 'Jost';
                    font-style: normal;
                    font-weight: 500;
                    font-size: 12px;
                    line-height: 20px;
                    color: #bebebe;
                  "
                >
                  {{ fileSize + ' KB' }}
                </span>
                <div
                  style="
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                  "
                >
                  <ProgressBar
                    :value="value1"
                    :showValue="false"
                    style="
                      flex-grow: 1;
                      height: 5px;
                      background: #eaeaea;
                      border-radius: 12px;
                    "
                  />
                  <span
                    style="
                      font-family: 'Jost';
                      font-style: normal;
                      font-weight: 400;
                      font-size: 16px;
                      line-height: 20px;
                      color: #444444;
                      margin-left: 0.5rem;
                    "
                  >
                    {{ '%' + value1 }}
                  </span>
                </div>
              </div>
            </div>
            <div>
              <button
                @click="clearCV()"
                style="background-color: white; border: none"
              >
                <img loading="lazy" src="/img/fileTrashCan.png" />
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="terms">
        <div style="display: flex; align-items: baseline">
          <Checkbox
            inputId="accept1"
            name="accept1"
            value="Accept"
            v-model="v$.accept1.$model"
            style="width: 15px; height: 15px !important"
            :class="{ 'p-invalid': v$.accept1.$invalid && submitted }"
          />
          <label
            for="accept1"
            :class="{ 'p-error': v$.accept1.$invalid && submitted }"
            >{{ $t('accept') }}</label
          >

          <router-link @click="termsandcondition = !termsandcondition" to="">{{
            $t('terms')
          }}</router-link>
        </div>
        <div class="terms" style="margin-top: 0px">
          <div style="display: flex; align-items: baseline">
            <Checkbox
              inputId="accept2"
              name="accept2"
              value="Accept"
              v-model="v$.accept2.$model"
              style="width: 15px; height: 15px !important"
              :class="{ 'p-invalid': v$.accept2.$invalid && submitted }"
            />
            <label
              for="accept2"
              :class="{ 'p-error': v$.accept2.$invalid && submitted }"
              >{{ $t('accept') }}</label
            >

            <router-link @click="dataprivacy = !dataprivacy" to="">{{
              $t('personaldataprotection')
            }}</router-link>
          </div>
        </div>
      </div>

      <div
        style="
          display: flex;
          align-items: center;
          width: 100%;
          justify-content: flex-end;
        "
      >
        <Button
          class="login-button p-px-3"
          @click="hideDialog"
          style="
            width: 100px;
            height: 40px;
            border: 1px solid #fc6c2a;
            border-radius: 6px;
            background-color: white;
            display: flex;
            align-items: center;
            justify-content: center;
          "
        >
          <div
            style="
              font-family: 'Jost';
              font-style: normal;
              font-weight: 500;
              font-size: 16px;
              line-height: 24px;
              text-align: center;
              color: #fc6c2a;
            "
          >
            {{ $t('cancel') }}
          </div>
        </Button>

        <Button
          class="login-button p-px-3"
          type="submit"
          style="
            width: 100px;
            height: 40px;
            background: #fc6c2a;
            border-radius: 6px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-left: 15px;
          "
          label="Apply"
          :loading="loading"
          :disabled="!linkedinPage || loading"
          iconPos="right"
        />
      </div>
    </div>
  </form>
  <Dialog
    class="dialog"
    v-model:visible="termsandcondition"
    modal
    :header="$t('terms')"
    :style="{ width: '50rem' }"
    :breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
  >
    <iframe
      style="margin: auto; display: block; border: 0"
      :src="cvURL + terms[0].path + '#toolbar=0&navpanes=0'"
      width="600"
      height="800"
    ></iframe>
  </Dialog>
  <Dialog
    v-model:visible="dataprivacy"
    modal
    :header="$t('personaldataprotection')"
    :style="{ width: '50rem' }"
    :breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
  >
    <iframe
      style="margin: auto; display: block; border: 0"
      :src="cvURL + terms[1].path + '#toolbar=0&navpanes=0'"
      width="600"
      height="800"
    ></iframe>
  </Dialog>
</template>
<script>
import { mapState } from 'vuex'
import { required } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import { getItem } from '../store/localStorage'
// import { cvURL } from "../api/Services";
import { cvURL, post, refer } from '../api/Services'
import { get } from '@/api/Services'

export default {
  emits: ['hide-dialog'],
  props: {
    product: {
      type: Array,
      default: () => {},
    },
  },
  async created() {
    this.uploadCV = 'newCV'
    this.firstname = this.account.userParam?.firstname
    this.lastname = this.account.userParam?.lastname
    this.linkedinPage = this.account.userParam?.linkedin_page
    this.email = this.account.userParam?.email
    this.jobsId = this.product?.id
    await this.fetchUserRole()
    this.loading = false
  },
  setup: () => ({ v$: useVuelidate() }),

  validations() {
    return {
      firstname: {
        required,
      },

      lastname: {
        required,
      },
      linkedinPage: {
        required,
      },

      accept1: {
        required,
      },
      accept2: {
        required,
      },

      visibleLeft: true,
    }
  },
  data() {
    return {
      cvLink: process.env.VUE_APP_MEDIA_URL,
      dataTableClickName: '',
      expandedRows: [],
      checked: false,
      selectedCvView: false,
      cvs: [],
      selectedCv: null,
      user: {},
      denemeImage: null,
      cvURL: cvURL,
      submitted: false,
      firstname: '',
      lastname: '',
      linkedinPage: '',
      info: '',
      accept: '',
      errorBorderColor: '#B00020',
      colorRed: { color: '#B00020' },
      apply: getItem('apply'),
      uploadCV: null,
      accept1: '',
      accept2: '',
      loadingFile: false,
      jobsId: null,
      value1: 0,
      loading: true,
      fileType: null,
      fileName: null,
      fileInput: null,
      file: null,
      previewImage: null,
      display: false,
      message: '',
      uyari: 'Warning',
      referObj: {},
      showCV: false,
      rolesLookup: [],
      terms: [],
      termsandcondition: false,
      dataprivacy: false,
      doctype: null,
      isDelete: false,
      docxContent: null,
      cvData: [],
      cvappear: false,
      onLoadView: false,
      onLoadSelected: false,
      seconds: 0,
      intervalcvViewer: null,
      intervalCvSelectedViewer: null,
    }
  },
  unmounted() {},
  beforeUnmount() {
    // this.stopInterval();
  },
  watch: {
    cvappear: function () {
      if (!this.cvappear) {
        this.showCV = false
        this.onLoadView = false
        this.onLoadSelected = false
        this.seconds = 0
        this.selectedCvView = false
      }
    },
    cvs(newValue) {
      if (newValue.length > 0) {
        this.uploadCV = 'latestCV'
      }
    },

    isDelete(newValue) {
      if (newValue === true) {
        if (this.isDelete) {
          this.insertCandidate()

          post('Commons/Executer', this.user).then((data) => {
            if (data) {
              if (data[0].status === 0) {
                return
              } else {
                this.$toast.add({
                  severity: 'error',
                  summary: 'Error',
                  detail: data[0].message || 'Error occured!',
                  life: 3000,
                })
              }
            }
          })
        }
      }
    },
  },
  mounted() {
    this.getrolesLookup()
    this.getTerms()
    this.getCV()
  },
  methods: {
    async fetchUserRole() {
      await get('Users/Role')
    },
    async fetchFile() {
      await post('Commons/Executer', this.user).then((data) => {
        if (data) {
          this.cvappear = true
          this.doctype = false
          this.cvData = data
          if (!this.onLoadSelected && this.selectedCvView) {
            this.dataTableClickName = this.selectedCv.name
          }
          this.showCV = true
        }
      })
    },
    toDataUrl(url, callback) {
      var xhr = new XMLHttpRequest()
      xhr.onload = function () {
        callback(xhr.response)
      }
      xhr.open('GET', url)
      xhr.responseType = 'blob'
      xhr.setRequestHeader('Access-Control-Allow-Origin', '*')
      xhr.send()
    },

    async getCV() {
      this.user.sqlId = 53
      let parameters = [
        { parameter_name: 'pin_cand_cand_id', parameter_value: -1 },
        {
          parameter_name: 'pin_cand_user_id',
          parameter_value: this.account.userParam.id || -1,
        },
        { parameter_name: 'pin_output_type', parameter_value: 3 },
        { parameter_name: 'piv_search_text', parameter_value: '' },
      ]
      this.user.parameters = JSON.stringify(parameters)
      await post('Commons/Executer', this.user).then((data) => {
        if (data) {
          this.cvs = data
        }
      })
    },
    async formatDocx(event) {
      let file = event.target.files[0]

      if (file) {
        let reader = new FileReader()
        reader.readAsArrayBuffer(file)
      }
    },
    async insertCandidate() {
      this.user.sqlId = 14

      let parameters = [
        {
          parameter_name: 'pin_candidate_id',
          parameter_value: this.isDelete ? this.referObj.ReferenceId : -1,
        },
        {
          parameter_name: 'piv_command_type',
          parameter_value: this.isDelete ? 'D' : 'I',
        },
        { parameter_name: 'pin_referrer_user_id', parameter_value: -1 },
        { parameter_name: 'pin_job_opening_id', parameter_value: -1 },
        {
          parameter_name: 'piv_firstname',
          parameter_value: this.firstname ? this.firstname : '',
        },
        {
          parameter_name: 'piv_lastname',
          parameter_value: this.lastname ? this.lastname : '',
        },
        {
          parameter_name: 'piv_linkedin_page',
          parameter_value: this.linkedinPage ? this.linkedinPage : '',
        },
        {
          parameter_name: 'piv_email',
          parameter_value: this.email ? this.email : '',
        },
        {
          parameter_name: 'piv_mobile',
          parameter_value: this.mobile ? this.mobile : '',
        },
        {
          parameter_name: 'piv_additional_info',
          parameter_value: this.info ? this.info : '',
        },
        { parameter_name: 'pin_is_term1_accepted', parameter_value: 1 },
        { parameter_name: 'pin_is_term2_accepted', parameter_value: 1 },
        { parameter_name: 'piv_secondary_email', parameter_value: '' },
        {
          parameter_name: 'piv_phone',
          parameter_value: this.phone ? this.phone : '',
        },
        { parameter_name: 'pin_candidate_user_id', parameter_value: -1 },
        { parameter_name: 'pin_gender_id', parameter_value: -1 },
        { parameter_name: 'piv_birth_date', parameter_value: '' },
        { parameter_name: 'pin_location_country_id', parameter_value: -1 },
        { parameter_name: 'pin_location_city_id', parameter_value: -1 },
        { parameter_name: 'piv_headline', parameter_value: '' },
        { parameter_name: 'piv_current_title', parameter_value: '' },
        { parameter_name: 'piv_current_company', parameter_value: '' },
        { parameter_name: 'pin_year_of_experince', parameter_value: -1 },
        {
          parameter_name: 'pin_year_of_experince_in_field',
          parameter_value: -1,
        },
        { parameter_name: 'pin_education_level_id', parameter_value: -1 },
        { parameter_name: 'piv_graduated_from', parameter_value: '' },
        { parameter_name: 'pin_currency_type_id', parameter_value: -1 },
        { parameter_name: 'pin_current_salary', parameter_value: -1 },
        { parameter_name: 'pin_salary_type_id', parameter_value: -1 },
        { parameter_name: 'pin_expected_salary_type_id', parameter_value: -1 },
        { parameter_name: 'pin_expected_salary', parameter_value: -1 },
        {
          parameter_name: 'pin_expected_currency_type_id',
          parameter_value: -1,
        },
      ]
      this.user.parameters = JSON.stringify(parameters)

      return this.user
    },
    async getrolesLookup() {
      this.user.sqlId = 42
      let parameters = [
        //{ parameter_name: "pin_user_id", parameter_value: this.user.userId },
      ]
      this.user.parameters = JSON.stringify(parameters)

      await post('Commons/Executer', this.user).then((data) => {
        if (data) {
          this.rolesLookup = data
        }
      })
    },
    async getTerms() {
      this.user.sqlId = 43
      let parameters = [
        //{ parameter_name: "pin_user_id", parameter_value: this.user.userId },
      ]
      this.user.parameters = JSON.stringify(parameters)

      await post('Commons/Executer', this.user).then((data) => {
        if (data) {
          this.terms = data
          this.terms.map((each) => {
            if (each.path.split('.').length > 0) {
              this.doctype = each.path
                ? each.path.split('.')[1] === 'pdf'
                  ? 'PDF'
                  : 'DOC'
                : ''
            }
          })
        }
      })
    },
    //   handleLogin(isFormValid) {
    //   this.submitted = true;
    //   if (!isFormValid) {
    //     this.message = "No Valid";
    //     // this.refreshCode();
    //     return;
    //   }

    // },
    hideDialog() {
      this.$emit('hide-dialog')
    },
    async displayCV(cv) {
      this.user.sqlId = 53
      let parameters = [
        {
          parameter_name: 'pin_cand_user_id',
          parameter_value: cv.user_id,
        },
        { parameter_name: 'pin_cand_cand_id', parameter_value: -1 },
        { parameter_name: 'pin_output_type', parameter_value: 3 },
        { parameter_name: 'piv_search_text', parameter_value: '' },
      ]
      this.user.parameters = JSON.stringify(parameters)
      this.dataTableClickName =
        cv && cv.firstname && cv.lastname
          ? `${cv.firstname} ${cv.lastname}`
          : this.selectedCv && this.selectedCv.name
          ? this.selectedCv.name
          : 'Unknown Name'
      this.fetchFile()
    },
    clearCV() {
      this.fileType = null
      this.previewImage = null
    },
    async uploadImage(e) {
      this.value1 = 0
      const image = e.target.files[0]
      this.file = image
      const reader = new FileReader()

      this.fileType = image ? image.name.split('.').pop() : ''
      this.fileType.length > 1
        ? this.fileType === 'jpeg' ||
          this.fileType === 'jpg' ||
          this.fileType === 'png'
          ? (this.doctype = 'image')
          : this.fileType === 'doc' || this.fileType === 'docx'
          ? (this.doctype = 'DOC')
          : this.fileType === 'pdf'
          ? (this.doctype = 'PDF')
          : (this.doctype = null)
        : (this.doctype = null)
      if (this.doctype === 'DOC') {
        await this.formatDocx(e)
      }

      this.value1 = 50
      reader.readAsDataURL(image)
      reader.onload = (e) => {
        this.previewImage = e.target.result
        this.fileName = image.name
        this.fileSize = Number(image.size / 1024).toFixed(0)
        this.fileLoading = true
        this.value1 = 100
      }
    },
    uploadEvent() {
      this.value1 = 0
      this.$refs.fileInput.click()
    },
    handleLogin(isFormValid) {
      this.submitted = true
      if (!isFormValid) {
        return
      }
      if (
        this.fileType == null &&
        this.previewImage == null &&
        this.uploadCV == 'newCV'
      ) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Warning',
          detail: 'Please attach a CV',
          life: 3000,
        })
        return
      }
      if (this.uploadCV == 'latestCV' && !this.selectedCv) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Warning',
          detail: 'Please select a CV',
          life: 3000,
        })
        return
      }
      this.isfileattached = true
      this.user.sqlId = 13
      let parameters = [
        // { parameter_name: "pin_user_id", parameter_value: this.userId },
        {
          parameter_name: 'pin_referrer_user_id',
          parameter_value: this.account.userParam?.id,
        },
        { parameter_name: 'pin_job_opening_id', parameter_value: this.jobsId },
        { parameter_name: 'piv_firstname', parameter_value: this.firstname },
        { parameter_name: 'piv_lastname', parameter_value: this.lastname },
        { parameter_name: 'piv_linkedin_profile_json', parameter_value: '' },
        {
          parameter_name: 'piv_linkedin_page',
          parameter_value: this.linkedinPage,
        },
        { parameter_name: 'piv_email', parameter_value: this.email },
        { parameter_name: 'piv_mobile', parameter_value: '' },
        {
          parameter_name: 'piv_additional_info',
          parameter_value: this.info ? this.info : '',
        },
        {
          parameter_name: 'pin_is_term1_accepted',
          parameter_value: this.accept1 ? 1 : 0,
        },
        {
          parameter_name: 'pin_is_term2_accepted',
          parameter_value: this.accept2 ? 1 : 0,
        },
      ]
      this.user.parameters = JSON.stringify(parameters)
      this.loading = true
      post('Commons/Executer', this.user)
        .then((data) => {
          //this.loadingFile = true;

          if (data) {
            //this.loading = false;

            if (data[0].status == 0) {
              this.referObj.ReferenceId = data[0].candidate_id
              this.referObj.CreateUser = this.account.userParam?.id
              this.referObj.FileTypeId = 5
              this.referObj.Description =
                this.info === ''
                  ? 'Candidate CV for Job #' + data[0].candidate_id
                  : this.info
              this.referObj.file = this.previewImage
              this.uploadCV == 'newCV'
                ? (this.referObj.File = this.file)
                : (this.referObj.SourceFileId = this.selectedCv?.id)

              refer(this.referObj).then(
                () => {
                  this.$toast.add({
                    severity: 'success',
                    summary: 'Success',
                    detail: data[0].message,
                    life: 3000,
                  })
                },
                (error) => {
                  this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error,
                    life: 3000,
                  })
                  this.isDelete = true
                }
              )
            } else {
              this.$toast.add({
                severity: 'warn',
                summary: 'Warning',
                detail: data[0].message,
                life: 3000,
              })
            }
          }
        })
        .finally(() => {
          this.loading = false
          this.$emit('hide-dialog')
          this.$emit('reload')
        })
    },
    collapse() {},
  },
  computed: {
    ...mapState({
      account: (state) => state.account,
    }),
  },
}
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.terms {
  width: 100%;
  line-height: 24px;
  text-align: center;
  color: rgba(48, 57, 82, 0.71);
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;

  label {
    margin: auto 0;
    padding-inline-start: 4px;
    transform: translateY(12%);
  }

  a {
    color: $text-link;
    transform: translateY(12%);
    margin-left: 0.5em;
  }
}

.product-image {
  // width: 150px;
  // box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23)
  width: 85px;
  height: 25px;
  margin-left: 0.5rem;
}

.upload-container {
  width: 100%;

  .upload-card {
    border-width: 2px;
    border-style: dashed;
    border-color: #c2c2c2;
    border-radius: 14px;
    padding: 19px 26px;
    background-color: #f5f5f5;

    .drop_box {
      display: flex;
      cursor: pointer;
      gap: 13px;

      .upload-text {
        display: flex;
        flex-direction: column;

        span:first-child {
          font-style: normal;
          font-weight: 600;
          font-size: 16px;
          line-height: 23px;
          color: #444444;
        }

        span:last-child {
          font-weight: 600;
          font-size: 16px;
          line-height: 23px;
          color: rgba(68, 68, 68, 0.5);
        }
      }
    }
  }
}

::v-deep(.p-progressbar .p-progressbar-value) {
  background: #fc6c2a !important;
}

::v-deep(.p-paginator-bottom) {
  margin-top: 0px !important;
}

::v-deep(.p-dialog-content) {
  padding: 2rem 2rem 2rem 2rem;
  margin: auto;
  width: fit-content;
}

::v-deep(.p-dialog .p-dialog-header) {
  background-color: #fc6c2a;
  padding: 10px 1.25rem 10px 1.25rem !important;
}

::v-deep(.p-checkbox-box) {
  width: 15px !important;
  height: 15px !important;
}

label {
  margin-bottom: 0px;
  cursor: pointer;
}

::v-deep(.p-placeholder) {
  opacity: 1 !important;
}

::v-deep(.upload-container .p-dropdown-label.p-inputtext) {
  padding: 0 !important;
}

/* we will explain what these classes do next! */
.v-enter-active,
.v-leave-active {
  transition: opacity 0.3s ease-in-out;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
